module.exports = __webpack_public_path__ + "static/media/lobby.b4ba6b8d.mp3";